/**
 * 系统菜单
 */
export default [
  {
    label: 'menu.txt001', //工作台
    icon: 'm-workbench',
    path: '/index',
    id: '0'
  }
]
